import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchRateLimit, updateRateLimit } from "actions/rateLimit";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/RateLimit/Form";

class RateLimitEdit extends Component {
  componentDidMount() {
    const { match, fetchRateLimit } = this.props;
    const id = match.params.rateLimitId;
    fetchRateLimit(id);
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.rateLimit.data;

    return Object.assign(
      {},
      {
        ...rest
      }
    );
  }

  updateRateLimit(id, data) {
    const { toggleNotification, toggleFullPageSpinner, updateRateLimit, history } = this.props;

    toggleFullPageSpinner(true);

    updateRateLimit(id, data)
      .then(() => {
        toggleNotification(true, { message: "Updated RateLimit Success", infoClassName: "is-success" });
        history.push(`/rate-limits`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.rateLimitId;

    this.updateRateLimit(id, data);
  };

  render() {
    const { rateLimit } = this.props;

    if (rateLimit.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return <Form handleFormSubmit={this.handleFormSubmit} defaultValues={defaultValues} />;
  }
}

const mapStateToProps = ({ rateLimit }) => ({
  rateLimit
});

export default connect(
  mapStateToProps,
  {
    fetchRateLimit,
    updateRateLimit,
    toggleFullPageSpinner,
    toggleNotification
  }
)(RateLimitEdit);



// WEBPACK FOOTER //
// ./src/pages/RateLimit/Edit/index.js